import { VisualizatorSettings } from "../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../web-graphics";

export class ChannelConfigurationPlotSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    this.signals = [];
    this.isolines = [];
    this.plotContent = [];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "name_configuration") {
        this.name_configuration = settings.name_configuration;
      } else if (key == "signals") {
        this.signals = VisualizatorSettings.copySettingsArray(settings.signals);
      } else if (key == "isolines") {
        this.isolines = VisualizatorSettings.copySettingsArray(settings.isolines);
      } else if (key == "plotContent") {
        this.plotContent = {};
        for (const contentKey of Object.getOwnPropertyNames(settings.plotContent)) {
          let placedPlotContent = settings.plotContent[contentKey];
          let placedPlotContentCopy = [];
          for (let contentIndex = 0; contentIndex < placedPlotContent.length; contentIndex++) {
            placedPlotContentCopy.push(placedPlotContent[contentIndex].copy()); // type: PlotContentSettings
          }
          this.plotContent[contentKey] = placedPlotContentCopy;
        }
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new ChannelConfigurationPlotSettings(this);
  }
}
